import { render, staticRenderFns } from "./B_hello-world.vue?vue&type=template&id=3bb58afa&scoped=true&"
import script from "./B_hello-world.vue?vue&type=script&lang=js&"
export * from "./B_hello-world.vue?vue&type=script&lang=js&"
import style0 from "./B_hello-world.vue?vue&type=style&index=0&id=3bb58afa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb58afa",
  null
  
)

export default component.exports